import styled from 'styled-components';
import { Dispatch, SetStateAction } from 'react';

type HamburgerMenuProps = {
  isOpen: boolean;
  toggleOpen: Dispatch<SetStateAction<boolean>>;
};

function HamburgerMenu({ toggleOpen, isOpen }: HamburgerMenuProps) {
  const onHamburgerMenuClick = () => {
    toggleOpen(!isOpen);
  };

  return (
    <MenuIcon $isOpen={isOpen} onClick={onHamburgerMenuClick}>
      <span />
      <span />
      <span />
    </MenuIcon>
  );
}

const MenuIcon = styled.div<{ $isOpen: boolean }>`
  display: inline-block;
  cursor: pointer;
  position: relative;
  width: 30px;
  height: 20px;

  span {
    display: block;
    position: absolute;
    width: 100%;
    height: 2px;
    background-color: ${({ theme }) => theme.colors.textPrimary};
    border-radius: 2px;
    transition:
      transform 0.3s,
      opacity 0.3s;
  }

  span:nth-child(1) {
    top: 0;
    transform: ${({ $isOpen }) =>
      $isOpen ? 'translateY(8px) rotate(45deg)' : 'none'};
  }

  span:nth-child(2) {
    top: 8px;
    opacity: ${({ $isOpen }) => ($isOpen ? 0 : 1)};
  }

  span:nth-child(3) {
    top: 16px;
    transform: ${({ $isOpen }) =>
      $isOpen ? 'translateY(-8px) rotate(-45deg)' : 'none'};
  }
`;

export default HamburgerMenu;
